import React from "react";
import { useParams } from "react-router-dom";
import NumericLabel from 'react-pretty-numbers';
import { Button, Dialog, DialogContent, DialogTitle, DialogActions, Paper, Typography, TableContainer, Table, TableHead, TableRow, TableCell, Box, IconButton, TableBody } from '@material-ui/core';
import { Error as ErrorIcon, Launch as LaunchIcon } from '@material-ui/icons';
import { prettyNumberParamsDB } from '../../../constants';
const PreviousSVErrorModal = ({ previousSVError, assetType, toggleModalFn ,event}) => {
    const params = useParams();
    return (
        <>
            <Dialog
                open={previousSVError.modal}
                onClose={toggleModalFn}
                className='server-error-modal'
                maxWidth={assetType === "engine" || event?.asset_type === 2 ?"md" : "sm"}
                fullWidth
            >
                <DialogTitle id="scroll-dialog-title">
                    Verify Amount Error
                </DialogTitle>
                <DialogContent dividers>
                    <Box display="flex" alignItems="start" style={{ marginBottom: "4px" }}>
                        <ErrorIcon fontSize="small" color="error" style={{ marginRight: 8 }} />
                        <h4>{previousSVError.errorMessage ? previousSVError.errorMessage : "Amount verification failed as you already have claimed."}</h4>
                    </Box>
                    <TableContainer component={Paper}>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell><strong>Shopvisit Name</strong></TableCell>
                                    <TableCell><strong>Claim Amount</strong></TableCell>
                                    {assetType === "engine" || event?.asset_type === 2 ?<TableCell><strong>LLP Claim Amount</strong></TableCell>:null}
                                    {assetType === "engine" || event?.asset_type === 2 ?  <TableCell><strong>PRSV Claim Amount</strong></TableCell>:null}
                                    <TableCell><strong>Action</strong></TableCell>
                                </TableRow>
                            </TableHead>
                                <TableBody>
                                    {previousSVError.data?.map(item => (
                                        <TableRow key={item.shop_visit_id}>
                                            <TableCell>{item.shop_visit_name}</TableCell>
                                                 <TableCell>{item.shop_visit_claim_amount  ? <NumericLabel  params={prettyNumberParamsDB}>{item.shop_visit_claim_amount}</NumericLabel> :'--'}</TableCell>
                                            {assetType === "engine" || event?.asset_type === 2 ? <TableCell>{item.shop_visit_llp_claim_amount ?
                                                <NumericLabel  params={prettyNumberParamsDB}>{item.shop_visit_llp_claim_amount}</NumericLabel> :'--'}
                                            </TableCell> : null}
                                            {assetType === "engine" || event?.asset_type === 2 ? <TableCell>
                                                {item.shop_visit_prsv_claim_amount ?
                                                <NumericLabel  params={prettyNumberParamsDB}>{item.shop_visit_prsv_claim_amount}</NumericLabel> :'--'}
                                            </TableCell> : null}
                                            <TableCell>
                                                <IconButton
                                                    color="error"
                                                    onClick={() => {
                                                        const url = `/${params.assetType}/${params.assetSlug}/maintenance/${assetType}/view/${item.shop_visit_id}`;
                                                        window.open(url, "_blank");
                                                    }}
                                                >
                                                    <LaunchIcon color="primary" />
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                        </Table>
                    </TableContainer>
                </DialogContent>
                <DialogActions>
                    <Button onClick={toggleModalFn} color='primary' size='small' variant='outlined'>Close</Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
export default PreviousSVErrorModal;